import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { Button, IconDispatcher } from "shared/ui-basics";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import PersonaBadge from "features/journey-map/cards/PersonaBadge";
import _ from "lodash";

export const BulkUnlinkPersonas = ({allRecordsSelector, recordIds, handleUnlink = () => {} }) => {
    const { t } = useTranslation();
    const allRecords = useSelector((state) => _.get(state, allRecordsSelector) || [])
	const selectedRecords = allRecords?.filter((ins) => recordIds?.includes(ins?.id));
	const allPersonas = useSelector((state) => state.personas.all_personas);

	const [show, setShow] = useState(false);

	const handleToggle = (isOpen) => {
		setShow(isOpen);
    };

    const getAllLinkedPersonas = () => {
		const linkedPersonaIds = [];
		const linkedPersonas = [];
		selectedRecords?.forEach((rec) => {
			rec?.linkedPersonas?.forEach((linkedPersonaId) => {
				if (!linkedPersonaIds?.includes(linkedPersonaId)) {
					linkedPersonaIds.push(linkedPersonaId);
					linkedPersonas.push(allPersonas?.find((p) => p?.personaId === linkedPersonaId));
				}
			});
		});
		return linkedPersonas;
	};

    const linkedPersonas = getAllLinkedPersonas();

	return (
		<DropDownContainer drop="up" show={show} onToggle={handleToggle}>
			<Dropdown.Toggle id="dropdown-custom-components" as={Button} variant="light-bulk">
				<ActionContainer>
					<div className="me-2">{IconDispatcher("user-xmark")}</div>
					<div>{t("UNLINK_PERSONA")}</div>
				</ActionContainer>
			</Dropdown.Toggle>
			<MenuContainer>
				{linkedPersonas?.length > 0 ? (
					<ListContainer>
						{linkedPersonas?.map((linkedPersona) => (
							<PersonaBadge key={linkedPersona?.personaId} object={linkedPersona} unlink={handleUnlink} isEdit={true} classNames="" />
						))}
					</ListContainer>
				) : (
					t("NO_DATA_AVAILABLE")
				)}
			</MenuContainer>
		</DropDownContainer>
	);
};

BulkUnlinkPersonas.displayName = "BulkUnlinkPersonas";

const DropDownContainer = styled(Dropdown)`
	.dropdown-toggle::after {
		display: none;
	}
	.dropdown-menu {
		padding: 0px;
		margin: 0px;
	}
`;

const MenuContainer = styled(Dropdown.Menu)`
    padding: 8px !important;
	width: 392px;
	height: fit-content;
	transform: translate3d(0px, -54px, 0px) !important;
`;

const ListContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`;

const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	font-size: 14px;
`;
